export default __webpack_public_path__ + "static/media/landingImage.fedab25f.svg";